import axios from "axios";
let development = false;
//layi

let downloadUrl = "";
//export default downloadUrl = development ? "http://127.0.0.1:7038/api" : "https://rouzo-boost-backend-2cv7.onrender.com/api"
export default downloadUrl = development ? "http://127.0.0.1:7038/api" : "https://rouzo-boost-backend-alpha.onrender.com/api"
